import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaCheckCircle } from "react-icons/fa";
import aboutimage from '../assets/images/about-image2.jpg';

const features = [
    {
        title: 'Transform Raw Footage into Masterpieces',
        description:
            'Share your clips and vision — we’ll handle the edit from start to finish. Our editors craft scroll-stopping content that’s tailored to your brand and audience.'
    },
    {
        title: 'Record Freely, We’ll Handle the Rest',
        description:
            'Simply upload your video files and tell us what you’re aiming for. Our team will shape your footage into a professional final cut that feels uniquely yours.'
    },
    {
        title: 'Fast Delivery Without Compromise',
        description:
            'We know time matters — that’s why we deliver quickly and consistently. Expect top-tier quality edits delivered on time, every time, without fail.'
    },
    {
        title: 'Flexible Pricing That Fits You',
        description:
            'Only pay for the editing services you actually need. Whether it’s a short Reel or a long-form vlog, our pricing is transparent and commitment-free.'
    },
    {
        title: 'Effortless Results, Every Time',
        description:
            'Relax while we do the heavy lifting — your fully edited video arrives in as little as 24 hours. Enjoy unlimited revisions until it’s perfect.'
    }
];

function About() {

    return (
        <section className="about">
            <Container>

                <Row className="about-image-inner">
                    {/* Left side - placeholder for image or content */}
                    <Col xs={12} md={12} lg={6}>
                        {/* You can place an image or illustration here */}
                        <div className='about-image'>
                            <img src={aboutimage} alt="Project Visual" className="img-fluid" />
                        </div>
                    </Col>

                    {/* Right side - text content only */}
                    <Col xs={12} md={12} lg={6} className="about-content-inner">
                        <h2>Why Creators Choose Us</h2>
                        {features.map((item, index) => (
                            <div key={index} className="d-flex">
                                <FaCheckCircle className="text-success me-3" size={32} />
                                <div className='item'>
                                    <strong>{item.title}</strong>
                                    <p className="mb-0">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default About;